import { useEffect, useState } from "react";
import LookupField from "../Theme/LookupField"
import { saveFormData } from "./FormUtils";
import axiosInstance from "../../api/axiosInstance";
import Swal from 'sweetalert2';
import MedicalTemplatePrescriptionFormRxList from "./MedicalTemplatePrescriptionFormRxList";
export default function MedicalTemplatePrescriptionForm({ saveTrigger, onSave, initialValues = null }) {
    const defaultFormData = {
        id: null,
        user_id: null,
        template_name: null,
    }
    const [form, setForm] = useState(defaultFormData);
    const [rxList, setRxList] = useState([]);
    const [clearTrigger, setClearTrigger] = useState(0);

    const handleFormValueChange = (item, newValue) => {
        setForm((prev) => ({
            ...prev,
            [item]: newValue,
        }));
    }
    useEffect(() => {
        if (saveTrigger > 0) {
            save()
        }
    }, [saveTrigger]);

    const save = () => {
        if (!form.user_id || !form.template_name) {
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Template Name and User/Doctor are required fields.',
            });
            onSave(false);
            return;
        }
        const rxIds = rxList.map(item => item.id);
        const payload = {
            name: form.template_name.value,
            value: rxIds,
            user_id: form.user_id.value,
            id: form.id,
            type: "prescriptions"
        };
        saveFormData(payload, onSave);
    }
    const deleteRxFromList = (index) => {
        setRxList((prev) => {
            const newList = [...prev];
            newList.splice(index, 1);
            return newList;
        });
    }
    const addSelectedRx = (id) => {
        let request = axiosInstance.post("medicalTemplates/fetchInitialValues/prescriptions", {
            rxList: [id],
        });
        request.then(response => {
            if (response.data.success) {
                if (rxList.findIndex(item => item.id == id) !== -1) {
                    return;
                }
                setRxList((prev) => [
                    ...prev,
                    response.data.data.rxList[0]
                ])
            } else {
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: response.data.message || 'Failed to save template. Please try again later.',
                });
            }
        }).catch(error => {
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Failed to save template. Please try again later.',
            });
            console.error("Error saving template:", error);
        });
    }

    const fetchInitialValues = async (values) => {
        if ((!values.value || values.value.length === 0) && (!values.user_id || values.user_id === null)) {
            setForm(values);
        } else {
            await axiosInstance.post("medicalTemplates/fetchInitialValues/prescriptions", {
                rxList: values.value || [],
                userId: values.user_id?.value || null
            }).then(response => {
                const data = response.data.data;
                if (data.userId) {
                    values.user_id = { value: data.userId.id, label: data.userId.text };
                }
                setForm(values);
                setRxList(data.rxList || []);
            }).catch(error => {
                console.error("Error fetching initial items:", error);
            });
        }
    }

    const parseData = async () => {
        if (!initialValues) {
            return null;
        }

        if (!initialValues.value) {
            initialValues.value = [];
        } else {
            try {
                if (!Array.isArray(initialValues.value)) {
                    initialValues.value = JSON.parse(initialValues.value);
                    if (!Array.isArray(initialValues.value)) {
                        initialValues.value = [initialValues.value];
                    }
                }
            } catch (error) {
                console.error("Error parsing initial values:", error);
            }
        }

        initialValues.template_name = { value: initialValues.name } || null;
        if (initialValues.user_id && !initialValues.user_id?.value) {
            initialValues.user_id = { value: initialValues.user_id } || null;
        }
        await fetchInitialValues(initialValues);
    }
    useEffect(() => {
        parseData();
    }, [initialValues])

    return (<div>
        <div className="row">
            <div className="col-md-6">
                <div className="form-group">
                    <label>Template Name&nbsp;<span className="text-danger">*</span></label>
                    <input type="text" className="form-control p-2" value={form?.template_name?.value || ""} onInput={(e) => {
                        handleFormValueChange("template_name", { value: e.target.value })
                    }} />
                </div>
            </div>
            <div className="col-md-6">
                <div className="form-group">
                    <label>User/Doctor&nbsp;<span className="text-danger">*</span></label>
                    <LookupField initialValue={form.user_id} onChange={(newValue) => {
                        handleFormValueChange("user_id", newValue)
                    }} url="searchUsersList?search=" />
                </div>
            </div>
        </div>
        <div className="row">
            <div className="col-md-12">
                <div className="form-group">
                    <label>Choose from Rx Standard List<br /></label>
                    <LookupField clearTrigger={clearTrigger} onChange={(newValue) => {
                        if (!newValue) return;
                        addSelectedRx(newValue.value)
                        setClearTrigger(prev => prev + 1)
                        setTimeout(() => {
                            setClearTrigger(0)
                        }, 100);
                    }} url="searchStdRxList?search=" />
                </div>
            </div>
        </div>
        <div className="row mt-2">
            <div className="col-md-12">
                <MedicalTemplatePrescriptionFormRxList handleDelete={deleteRxFromList} items={rxList} />
            </div>
        </div>
    </div>)
}